import { StudyDocumentsFile, StudyDocumentsService } from '@csp/csp-common-file-storage';
import { minutesToMillis } from '@csp/csp-common-date-util';
import { Maybe } from '@csp/csp-common-model';
import { useQuery } from '../../../common/query/hooks/useQuery';

export const GET_TRAINING_DOCUMENTS_CACHE_KEY = 'GET_TRAINING_DOCUMENTS';

const queryArgs = [
  { cacheKey: GET_TRAINING_DOCUMENTS_CACHE_KEY },
  StudyDocumentsService.getAllUserResources,
  {
    staleTimeMillis: minutesToMillis(10),
  },
] as const;

export const useTrainingDocuments = (): Maybe<StudyDocumentsFile[]> => {
  const { data: userResources } = useQuery(...queryArgs);
  return userResources;
};
